// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dcPp","nav":"styles_nav__1atpE","navItem":"styles_navItem__1ZNEU","content":"styles_content__qgAUr","activeNavItem":"styles_activeNavItem__23TE8"};